import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'journey-booking';
const BLOCK_ID = 'journey-booking';
const PLACEHOLDER_LABEL = 'Reisebuchung';

export default function journeyBooking(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-journey-booking') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }

            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: 'Reisebuchung',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-journey-booking',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [{}],
            },
        },
        view: {},
    });
    blockManager.add(BLOCK_ID, {
        label: 'Reisebuchung',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14Zm-2-8h-4V7h-2v4H7v2h4v4h2v-4h4v-2Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-journey-booking',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
